import FormatException from '../Exceptions/FormatException';
import isNullOrEmpty from '../TypeHelpers/isNullOrEmpty';
/** Formats strings */
export default class StringFormatter {
    format(subject, format) {
        if (isNullOrEmpty(format)) {
            return subject;
        }
        else {
            switch (format) {
                case 'L': return subject.toLowerCase();
                case 'U': return subject.toUpperCase();
                default: throw new FormatException(`The format '${format}' is not implemented`);
            }
        }
    }
}
